/** Inline Overview "Reopen" control next to Complete status badge. */
export default function ReopenVqqStatusButton({ visible, onClick }) {
  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center rounded-md bg-white px-2.5 py-1 text-xs font-semibold text-indigo-700 shadow-sm ring-1 ring-inset ring-indigo-200 hover:bg-indigo-50"
    >
      Reopen
    </button>
  );
}
